export const SIDEBAR_WIDTH_PX = 320;
export const ONE_TASK_MISSING_LABWARE = 'ONE_TASK_MISSING_LABWARE';

export enum LabwareCorrespondenceType {
  COMMON_LABWARE = 'COMMON_LABWARE',
  NO_LABWARE_ASSIGNED = 'NO_LABWARE_ASSIGNED',
  DIFFERENT_LABWARE = 'DIFFERENT_LABWARE',
}
